<template>
<div class="c-step step-5">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy około 1 godzinna procedura wydania auta
      nie spowoduje zaburzenia funkcjonowania tego
      miejsca?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step5',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '5',
        answer: answer
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
